import * as React from "react"

function ProfitIcon({...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 32 32"
      {...props}
    >
      <path fill="#ed4669" d="M2.5 23.5h3a1 1 0 011 1v7h-5v-7a1 1 0 011-1z" />
      <path
        fill="#55bb8c"
        d="M10.5 16.5h3a1 1 0 011 1v14h-5v-14a1 1 0 011-1z"
      />
      <path
        fill="#ed4669"
        d="M18.5 20.5h3a1 1 0 011 1v10h-5v-10a1 1 0 011-1z"
      />
      <path
        fill="#55bb8c"
        d="M26.5 16.5h3a1 1 0 011 1v14h-5v-14a1 1 0 011-1z"
      />
      <circle cx={20} cy={6.5} r={6} fill="#fedc55" />
      <path d="M20 13a6.5 6.5 0 10-6.5-6.5A6.508 6.508 0 0020 13zm0-12a5.5 5.5 0 11-5.5 5.5A5.507 5.507 0 0120 1zm10.987 8.438a.457.457 0 00-.082-.215s0-.011-.008-.016L30.89 9.2a.489.489 0 00-.141-.124A.487.487 0 0030.5 9h-3a.5.5 0 000 1h1.53l-9.02 6.864-7.694-6.252a.5.5 0 00-.651.018L1.2 20.13a.5.5 0 10.672.74l10.143-9.211 7.666 6.229a.5.5 0 00.618.01L30 10.519V12.5a.5.5 0 001 0v-3a.466.466 0 00-.013-.062zM21.5 20h-3a1.5 1.5 0 00-1.5 1.5v10a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-10a1.5 1.5 0 00-1.5-1.5zm.5 11h-4v-9.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zM20.5 9h-1a1 1 0 01-1-1 .5.5 0 00-1 0 2 2 0 002 2v.5a.5.5 0 001 0V10a2 2 0 000-4h-1a1 1 0 010-2h1a1 1 0 011 1 .5.5 0 001 0 2 2 0 00-2-2v-.5a.5.5 0 00-1 0V3a2 2 0 000 4h1a1 1 0 010 2zm-15 14h-3A1.5 1.5 0 001 24.5v7a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-7A1.5 1.5 0 005.5 23zm.5 8H2v-6.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zm7.5-15h-3A1.5 1.5 0 009 17.5v14a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-14a1.5 1.5 0 00-1.5-1.5zm.5 15h-4V17.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zm15.5-15h-3a1.5 1.5 0 00-1.5 1.5v14a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-14a1.5 1.5 0 00-1.5-1.5zm.5 15h-4V17.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5z" />
    </svg>
  )
}

export default ProfitIcon
